export default __webpack_public_path__ + "static/media/actividad-7.db4b14ba.mp3";